import { Box, Grid2 as Grid, Stack, ToggleButton, Typography } from '@mui/material';
import React from 'react';
export const MultipleChoiceToggle = ({ name, question, options, selectedOption, handleFormValues, }) => {
    return (React.createElement(Box, { mb: 3 },
        React.createElement(Typography, { mb: 0.5, fontSize: "14px", fontWeight: 500, color: "secondary.dark" }, question),
        React.createElement(Grid, { container: true, spacing: 1 }, options.map(({ label, value, description }) => (React.createElement(Grid, { key: value, size: { xs: 12, sm: 4 } },
            React.createElement(ToggleButton, { value: value, color: "primary", selected: value === selectedOption, sx: {
                    p: 2,
                    width: '100%',
                    height: '100%',
                    borderRadius: '8px',
                    borderColor: value === selectedOption ? 'success.light' : '',
                }, onClick: () => handleFormValues(name, value) },
                React.createElement(Stack, { gap: 0.3, width: "100%", height: "100%", alignItems: "flex-start" },
                    React.createElement(Typography, { fontSize: "14px", fontWeight: 600, textTransform: "none", color: "secondary.dark" }, label),
                    React.createElement(Typography, { fontSize: "14px", fontWeight: 500, textAlign: "start", textTransform: "none", color: "secondary.light" }, description)))))))));
};
